const initials = "allProducts/";
export const UPDATE_ALL_PRODUCTS_REDUCER = `${initials}UPDATE_ALL_PRODUCTS_REDUCER`;
